import { type RefObject, useEffect } from 'react';

interface IUseScrollIntoViewProps {
  element: RefObject<HTMLElement | null>;
  condition: boolean;
}

function useScrollIntoView({ element, condition }: IUseScrollIntoViewProps) {
  useEffect(() => {
    if (condition) {
      element?.current?.scrollIntoView({ block: 'nearest' });
    }
  }, [condition, element]);
}

export default useScrollIntoView;
